import 'date-fns';
import React from 'react';

import autoBind from 'react-autobind';
import DateFnsUtils from '@date-io/date-fns';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import Helper from "composer/Helper.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Icon,
} from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

class PushDownloadDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,

      selectedOption: null,
      isViewPublic: false,
      searchText: "",
      mySchoolLocaleList: [],
      localeList: [],
      startDateTime: new Date(),
      endDateTime: new Date(),
      targetUsername: "",
    };
    autoBind(this);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleEnter() {
    let currentTime = new Date();
    let oneWeekFromNow = new Date(currentTime);
    // 1 week = 604800000 milliseconds
    oneWeekFromNow.setTime(currentTime.getTime() + 604800000);
    this.setState({
      startDateTime: currentTime,
      endDateTime: oneWeekFromNow,
    });
    this.state.startDateTime = currentTime;
    this.state.endDateTime = oneWeekFromNow;

    let requestObj = {
      filter: {},

    }

    requestObj.filter['school_id'] = this.props.root.getMySchoolId();

    this.props.root.refs.API.request("get_locale_list", requestObj, this.getLocaleListOK, this.getLocaleListFailed);
  }

  getLocaleListOK(res) {
    let tmpList = [];
    let localeList = res.body['result'];
    for (let i = 0; i < localeList.length; i++) {
      let localeRow = localeList[i];
      tmpList.push({
        locale_id: localeRow['id'],
        locale_name: localeRow['locale_name'],
      });
    }

    let tmpOptions = tmpList.map(locale => ({
      value: locale.locale_id,
      label: locale.locale_name,
    }));

    this.setState({ localeList: tmpOptions });
    this.state.localeList = tmpOptions;

    if (this.state.mySchoolLocaleList == 0) {
      this.setState({ mySchoolLocaleList: tmpOptions });
      this.state.mySchoolLocaleList = tmpOptions;
    }

    if (tmpOptions.length > 0) {
      this.setState({ selectedOption: tmpOptions[0]});
    }
  }

  getLocaleListFailed(err) {
    console.log("get locale list failed");
  }

  handleClose() {
    this.close();
  }

  closeCancelClicked() {

  }

  closeConfirmClicked() {
    this.close();
  }

  handleCancel() {
    this.handleClose();
  }

  onLocaleSelected = (event, selectedOption) => {
    this.setState({ selectedOption });
  }

  handleStartDateChange(date) {
    this.setState({ startDateTime: date });
    this.state.startDateTime = date;
  };

  handleEndDateChange(date) {
    let endDate = date;
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    this.setState({ endDateTime: endDate });
    this.state.endDateTime = endDate;
  }

  handleTargetChange(event) {
    this.setState({ targetUsername: event.target.value });
    this.state.targetUsername = event.target.value;
  }

  addPushDownloadItemClicked() {
    if (this.state.selectedOption == null) {
      this.props.root.addNotification(Localization.strings.LOCALE_INVALID_REMINDER);
      return;
    }

    if (this.state.endDateTime < this.state.startDateTime) {
      this.props.root.addNotification(Localization.strings.DATE_INVALID_REMINDER);
      return;
    }

    let requestObj = {
      "school_id": this.props.root.getMySchoolId(),
      "user_id": this.props.root.getMyUserId(),
      "time_from": Helper.dateToTimestamp(this.state.startDateTime),
      "time_to": Helper.dateToTimestamp(this.state.endDateTime),
      "target_username": this.state.targetUsername,
      "locale_id": this.state.selectedOption.value,
    }
    this.props.root.refs.API.request("add_push_download_item", requestObj, this.addPushDownloadItemOK, this.addPushDownloadItemFailed);
  }

  addPushDownloadItemOK(res) {
    this.props.root.addNotification(Localization.strings.CREATED);
    this.props.parent.reload();
    this.handleClose();
  }

  addPushDownloadItemFailed(err) {
    this.props.root.addNotification(Localization.strings.CREATE_FAILED);
  }

  onViewAngleChanged(e) {
    let isPublic = false;
    switch (e.target.value) {
      case 0:
        isPublic = false;
        break;
      case 1:
        isPublic = true;
        break;
      default:
        break;
    }

    this.setState({
      isViewPublic: isPublic,
      selectedOption: null,
    });
    this.state.isViewPublic = isPublic;
    this.state.selectedOption = null;

    this.handleClearClicked();

    if (!isPublic) {
      this.setState({ localeList: this.state.mySchoolLocaleList });
      this.state.localeList = this.state.mySchoolLocaleList;
    }
  }

  handleSearchClicked() {
    if (this.state.searchText != "") {
      let requestObj = {
        filter: {keyword: this.state.searchText},
        order_by: "id",
        order_mode: "DESC",
      }
      this.props.root.refs.API.request("get_locale_list", requestObj, this.getLocaleListOK, this.getLocaleListFailed);
    }
  }

  handleClearClicked() {
    this.setState({
      searchText: "",
      localeList: [],
    });
    this.state.searchText = "";
    this.state.localeList = [];
  }

  onInputChange = (event, newInputValue) => {
    this.setState({ searchText: newInputValue });
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onEnter={this.handleEnter}
          onClose={this.handleClose}
        >
          <DialogTitle>
            New Deployment
          </DialogTitle>

          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} sm={2}>
                VITALS
              </Grid>
              <Grid item xs={8} sm={10}>
                <div style={{display:'inline-block'}}>
                  <FormControl>
                    <InputLabel>{Localization.strings.SCHOOL}</InputLabel>
                    <Select
                      value={this.state.isViewPublic? 1 : 0}
                      onChange={this.onViewAngleChanged}
                    >
                      <MenuItem value={0}>{Localization.strings.MY_SCHOOL}</MenuItem>
                      <MenuItem value={1}>{Localization.strings.ALL_SCHOOLS}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div style={{display:'inline-block',verticalAlign:'bottom', padding:'0 0 0 8px'}}>
                  <Autocomplete
                    value={this.state.selectedOption}
                    options={this.state.localeList}
                    getOptionLabel={option => option.label}
                    inputValue={this.state.searchText}
                    onInputChange={this.onInputChange}
                    renderInput={params => <TextField {...params} margin="normal" style={{width:300, margin:"0px"}} />}
                    onChange={this.onLocaleSelected}
                    clearOnBlur={false}
                  />
                </div>
                <If condition={this.state.isViewPublic}>
                  <Then>
                    <div style={{display:'inline-block',verticalAlign:'bottom'}}>
                      <Tooltip title={Localization.strings.SEARCH}>
                        <IconButton
                          onClick={this.handleSearchClicked}
                        >
                          <Icon>search</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={Localization.strings.CLEAR}>
                        <IconButton
                          onClick={this.handleClearClicked}
                        >
                          <Icon>clear</Icon>
                        </IconButton>
                      </Tooltip>
                    </div>
                  </Then>
                </If>
              </Grid>
              <Grid item xs={8} sm={2}>
                Start
              </Grid>
              <Grid item xs={8} sm={10}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="start-date-picker-inline"
                      value={this.state.startDateTime}
                      onChange={this.handleStartDateChange}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={8} sm={2}>
                End
              </Grid>
              <Grid item xs={8} sm={10}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="end-date-picker-inline"
                      value={this.state.endDateTime}
                      onChange={this.handleEndDateChange}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={8} sm={2}>
                {Localization.strings.TARGET_USER}
              </Grid>
              <Grid item xs={8} sm={10}>
                <TextField
                  value={this.state.target_username}
                  helperText="optional"
                  onChange={this.handleTargetChange}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              onClick={this.handleCancel}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.addPushDownloadItemClicked}
            >
              {Localization.strings.CREATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default PushDownloadDialog;
